(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["spa-article-toc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var toc = document.querySelector('[data-spa-toc]:not([data-spa-init])');
  if (!toc) return;
  toc.dataset.spaInit = '1';
  var selector = toc.dataset.target || '.rte';
  var content = document.querySelector(selector);
  if (!content) return;
  var headings = content.querySelectorAll('h2');
  if (headings.length < 2) return;
  var list = toc.querySelector('[data-spa-toc-list]');
  headings.forEach(function (h, i) {
    if (!h.id) h.id = 'afsnit-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9æøå]+/g, '-').replace(/^-|-$/g, '');
    h.style.scrollMarginTop = '90px';
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    li.appendChild(a);
    list.appendChild(li);
  });
  toc.hidden = false;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spa-compare"] && !Shopify.designMode) return;
  try {
    
(function () {
  var table = document.querySelector('[data-spa-compare-table]:not([data-spa-init])');
  if (!table) return;
  table.dataset.spaInit = '1';
  var dataEl = document.querySelector('[data-spa-compare-data]');
  var selA = document.getElementById('spaCompareA');
  var selB = document.getElementById('spaCompareB');
  if (!dataEl || !selA || !selB) return;

  var models = [];
  try { models = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (models.length < 2) return;

  var kr = function (cents) { return Math.round(cents / 100).toLocaleString('da-DK') + ' kr'; };

  function fill(sel, selectedId) {
    sel.innerHTML = models.map(function (m) {
      return '<option value="' + m.id + '"' + (m.id === selectedId ? ' selected' : '') + '>' +
        m.name + (m.current ? ' (denne side)' : '') + '</option>';
    }).join('');
  }

  function card(m) {
    var cta = m.current
      ? '<span class="spa-compare-cta is-current">Du ser denne model</span>'
      : '<a class="spa-compare-cta" href="' + (m.url || '#') + '">Se ' + m.name + ' →</a>';
    return '<div class="spa-compare-card">' +
      '<div class="spa-compare-card-img">' + (m.img ? '<img src="' + m.img + '" alt="' + m.name + '" loading="lazy">' : '') + '</div>' +
      '<h3>' + m.name + '</h3>' +
      '<span class="spa-compare-card-sub">' + (m.sub || '') + '</span>' +
      '<div class="spa-compare-card-price"><span class="now">' + kr(m.price) + '</span>' +
      (m.oldPrice > m.price ? '<span class="old">' + kr(m.oldPrice) + '</span>' : '') + '</div>' +
      cta + '</div>';
  }

  function render() {
    var a = models.find(function (m) { return m.id === selA.value; });
    var b = models.find(function (m) { return m.id === selB.value; });
    if (!a || !b) return;
    var rows = Object.keys(a.specs).map(function (label) {
      var va = a.specs[label] || '—';
      var vb = b.specs[label] || '—';
      var diff = va !== vb ? ' is-diff' : '';
      return '<div class="spa-compare-row' + diff + '">' +
        '<div class="spa-compare-row-label">' + label + '</div>' +
        '<div class="spa-compare-row-val">' + va + '</div>' +
        '<div class="spa-compare-row-val">' + vb + '</div></div>';
    }).join('');
    table.innerHTML = '<div class="spa-compare-cards">' + card(a) + card(b) + '</div>' + rows;
  }

  var current = models.find(function (m) { return m.current; }) || models[0];
  var other = models.find(function (m) { return m.id !== current.id; });
  fill(selA, current.id);
  fill(selB, other.id);
  selA.addEventListener('change', render);
  selB.addEventListener('change', render);
  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spa-pdp-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  var nav = document.getElementById('spa-pdp-nav');
  if (!nav || nav.dataset.spaInit) return;
  nav.dataset.spaInit = '1';

  var links = Array.prototype.slice.call(nav.querySelectorAll('.spa-pdp-nav-link'));
  var sections = links
    .map(function (l) { var h = l.getAttribute('href'); return h && h.charAt(0) === '#' ? document.querySelector(h) : null; })
    .filter(Boolean);

  /* Scroll-offset så ankre lander under nav'en */
  sections.forEach(function (s) { s.style.scrollMarginTop = '64px'; });

  /* Pin-detektion via sentinel lige over nav'en */
  var sentinel = document.createElement('div');
  nav.parentElement.insertBefore(sentinel, nav);
  var headerEl = document.querySelector('#shopify-section-header, .shopify-section--header, [id^="shopify-section"][id*="header"]');
  var hideHeader = nav.dataset.hideHeader === 'true';

  new IntersectionObserver(function (entries) {
    var pinned = !entries[0].isIntersecting;
    nav.classList.toggle('is-pinned', pinned);
    if (hideHeader && headerEl) headerEl.classList.toggle('spa-header-hidden', pinned);
  }, { rootMargin: '0px 0px 0px 0px' }).observe(sentinel);

  /* Scrollspy */
  function setActive(id) {
    links.forEach(function (l) {
      var on = l.getAttribute('href') === '#' + id;
      l.classList.toggle('is-active', on);
      if (on) l.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
  }
  var spy = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) setActive(e.target.id); });
  }, { rootMargin: '-40% 0px -55% 0px' });
  sections.forEach(function (s) { spy.observe(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spalageret-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btn = document.getElementById('spToTop');
    if (!btn) return;
    var toggle = function () {
      if (window.scrollY > 600) { btn.classList.add('visible'); }
      else { btn.classList.remove('visible'); }
    };
    window.addEventListener('scroll', toggle, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    toggle();

    // Mobil-accordion: luk kolonner ved load på små skærme
    var mq = window.matchMedia('(max-width: 700px)');
    var cols = document.querySelectorAll('.sp-footer .sp-footer-col');
    var sync = function () {
      cols.forEach(function (c) { c.open = !mq.matches; });
    };
    sync();
    if (mq.addEventListener) { mq.addEventListener('change', sync); }
  })();

  } catch(e) { console.error(e); }
})();
})();
